import { Dimensions } from "@faire/slate/foundation/dimensions";
import { Check } from "@faire/slate-icons/Check";
import { Subtract } from "@faire/slate-icons/Subtract";
import { SVGIconComponent } from "@faire/slate-icons/types";

import { AriaChecked, CheckboxChecked } from "./types";

export const CHECKBOX_CHECKED = [true, "indeterminate", false] as const;

export const ICON_CLASSNAME_BY_CHECKBOX_CHECKED: Record<
  `${CheckboxChecked}`,
  string
> = {
  true: "fs-checkbox__icon--checked",
  indeterminate: "fs-checkbox__icon--indeterminate",
  false: "fs-checkbox__icon--unchecked",
};

export const ARIA_CHECKED_BY_CHECKBOX_CHECKED: Record<
  `${CheckboxChecked}`,
  AriaChecked
> = {
  true: "true",
  indeterminate: "mixed",
  false: "false",
};

export const ICON_BY_CHECKBOX_CHECKED: Record<
  `${CheckboxChecked}`,
  SVGIconComponent | undefined
> = {
  true: Check,
  indeterminate: Subtract,
  false: undefined,
};

export const CHECKBOX_ICON_SIZE_PX = Dimensions[2];
export const CHECKBOX_ICON_STOKE_WIDTH = 2.5;
